// extracted by mini-css-extract-plugin
module.exports = {"label-style":"label-style-2cd5f385"};